import { render, staticRenderFns } from "./add-resource.vue?vue&type=template&id=2056b9a4&scoped=true"
import script from "./add-resource.vue?vue&type=script&lang=ts"
export * from "./add-resource.vue?vue&type=script&lang=ts"
import style0 from "./add-resource.vue?vue&type=style&index=0&id=2056b9a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056b9a4",
  null
  
)

export default component.exports